import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const DirectionsFilledIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m21.41 10.59-7.99-8c-.78-.78-2.05-.78-2.83 0l-8.01 8c-.78.78-.78 2.05 0 2.83l8.01 8c.78.78 2.05.78 2.83 0l7.99-8c.79-.79.79-2.05 0-2.83M13.5 14.5V12H10v3H8v-4c0-.55.45-1 1-1h4.5V7.5L17 11z"
      fill="currentColor"
    />
  </svg>
);

DirectionsFilledIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(DirectionsFilledIcon);
